module.exports = __webpack_public_path__ + "img/registered.22bb1f02.svg";